module.exports = __webpack_public_path__ + "img/1_006.0cfaaa2e.jpg";